import { render, staticRenderFns } from "./ListFakeUsers.vue?vue&type=template&id=98d7345c&scoped=true"
import script from "./ListFakeUsers.vue?vue&type=script&lang=js"
export * from "./ListFakeUsers.vue?vue&type=script&lang=js"
import style0 from "./ListFakeUsers.vue?vue&type=style&index=0&id=98d7345c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d7345c",
  null
  
)

export default component.exports